module.exports = __webpack_public_path__ + "img/compressed-2018230266090360832.902c559a.png";